import ImagesPallet from "../../../../utils/ImagesPallet";

const HairstylistData = [
  {
    name: 'Tyo',
    image: ImagesPallet.Tyo,
    info: {
      specialties: [
        'Creative Hair Coloring',
        'Modern Hair Cuts',
        'Hair Styling'
      ],
      experience: '5+ years of experience in creative hair styling'
    }
  },
  {
    name: 'Indra',
    image: ImagesPallet.Indra,
    info: {
      specialties: [
        'Classic Hair Cuts',
        'Hair Treatment',
        'Scalp Care'
      ],
      experience: '8+ years of experience in hair care'
    }
  },
  {
    name: 'Eky',
    image: ImagesPallet.Eky,
    info: {
      specialties: [
        'Modern Styling',
        'Hair Styling',
        'Hair Coloring',
        'Trendy Cuts'
      ],
      experience: '6+ years of experience in modern hair styling'
    }
  },
  {
    name: 'Andhika',
    image: ImagesPallet.Andhika,
    info: {
      specialties: [
        'Modern Styling',
        'Hair Coloring',
        'Trendy Cuts'
      ],
      experience: '6+ years of experience in modern hair styling'
    }
  },
  {
    name: 'Arul',
    image: ImagesPallet.Arul,
    info: {
      specialties: [
        'Hair Treatment',
        'Hair Styling',
        'Color Specialist'
      ],
      experience: '7+ years of experience in hair care and coloring'
    }
  },
  {
    name: 'Johan',
    image: ImagesPallet.Johan,
    info: {
      specialties: [
        'Hair Treatment',
        'Hair Styling',
        'Color Specialist'
      ],
      experience: '7+ years of experience in hair care and coloring'
    }
  },
];

export default HairstylistData